import { Model } from "@vuex-orm/core";

export default class EproQuestionnaireResponse extends Model {
  static entity = "eproQuestionnaireResponses";

  static fields() {
    return {
      id: this.attr(null),
      bundleId: this.attr(null),
      patientId: this.attr(null),
      startPerformedDateTime: this.attr(null),
      programManagementId: this.attr(null),
      questionnaireCategory: this.attr(null),
      questionnaireId: this.attr(null),
      questionnaireResponseItems: this.attr([]),
      responseStatus: this.attr(null),
    };
  }

  static async getQuestionnaireResponse({
    programManagementId,
    bundleId,
    questionnaireId,
    patientUsername,
  }) {
    return await this.api().get("questionnaireResponse/patient", {
      dataKey: "result",
      params: {
        programManagementId,
        bundleId,
        questionnaireId,
        patientUsername,
      },
    });
  }
}
